import isString from 'lodash/isString';

export const isTeachPreview = (pathname: string): boolean => {
  if (!isString(pathname)) {
    throw new Error('pathname parameter is mandatory');
  }
  return /\/preview\//.test(pathname);
};
